import PropTypes from "prop-types";
import baller from "../assets/baller.svg";
import logo from "../assets/Tweezer-Logo.svg";
import mobileLogo from "../assets/mobile-logo.svg";

export default function AuthLayout({ children, imageSrc, filter }) {
  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-white">
      {/* Image Section */}
      <div className="w-full md:w-1/2 flex justify-center items-center md:h-screen order-1 md:order-2">
        <img
          src={imageSrc || baller}  // Default image
          alt="Glowing Soccer Ball"
          className={`hidden md:flex w-full rounded-bl-[90px] h-[270px] rounded-br-[90px] md:rounded-none md:h-full object-cover ${filter ? filter : ''}`}  // Apply filter prop if present
        />
      </div>
      
      {/* Form Section */}
      <div className="flex flex-col justify-center items-center px-6 py-10 w-full md:w-1/2 order-2 md:order-1">
        <div className="flex justify-center py-6">
          <img
            src={logo}
            alt="Tweezers logo"
            className="w-20 hidden md:block"
          />
          <img
            src={mobileLogo}
            alt="Tweezers logo"
            className="w-20 block z-40 animate__animated animate__rotateIn  md:hidden"
          />    
        </div>
        <div className="relative bottom-0 md:bottom-0 w-full max-w-sm">
          {children}
        </div>
      </div>
    </div>
  );
}

AuthLayout.propTypes = {
  children: PropTypes.node.isRequired,
  imageSrc: PropTypes.string,  // Optional prop for image source
  filter: PropTypes.string,    // Optional prop for image filter
};
